<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <ReportDefectResult
                :message="resultMessage"
                :icon="resultIcon"
                v-if="showResult"
            />

            <div class="col-md-5" v-if="!showResult">
                <h2>Nahlásenie poruchy svietidla</h2>
                <div class="card">
                    <div class="card-body">
                        <b-form @submit="onSubmit">
                            <b-form-group label="Zoznam porúch">
                                <b-form-checkbox-group
                                    v-model="defect.defects"
                                    :options="options"
                                    name="defects"
                                    stacked
                                ></b-form-checkbox-group>
                            </b-form-group>
                            <label for="textarea">Popis problému:</label>
                            <b-form-textarea
                                id="textarea"
                                v-model="defect.note"
                                placeholder="Vložte text"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                            <br/>
                            <h4>Kontaktné údaje</h4>
                            <label for="name">Meno:</label>
                            <b-form-input
                                id="name"
                                v-model="defect.name"
                                placeholder="Zadajte meno"
                            ></b-form-input>

                            <label for="phone" class="mt-3">Tel. číslo</label>
                            <b-form-input
                                id="phone"
                                v-model="defect.phone"
                                placeholder="Zadajte tel. číslo"
                            ></b-form-input>

                            <label for="email" class="mt-3">Email</label>
                            <b-form-input
                                id="email"
                                v-model="defect.email"
                                required
                                placeholder="Zadajte email"
                            ></b-form-input>

                            <b-form-checkbox
                                class="mt-3"
                                name="terms"
                                required
                                v-model="defect.agree"
                            >
                                <template #default>
                                    Súhlasím so
                                    <a
                                        href="/obchodne-podmienky"
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        spracovaním osobných údajov
                                    </a>
                                </template>
                            </b-form-checkbox>

                            <br/>
                            <b-button type="submit" block variant="primary"
                            >Odoslať
                            </b-button>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/store/api";
import ReportDefectResult from "@/components/public/ReportDefectResult";

export default {
    name: "ReportDefect",
    components: {ReportDefectResult},
    props: ["city", "point"],
    data() {
        return {
            result: null,
            showResult: false,
            resultMessage: null,
            resultIcon: null,
            defect: [],
            options: {
                1: "Svietidlo nesvieti",
                2: "Svietidlo bliká",
                3: "Celá ulica nesvieti",
                4: "Celá oblasť nesvieti",
                5: "Rozvádzač nesvieti",
                6: "Poškodený/chýbajúci kryt svorkovnice",
                7: "Poškodený/ohnutý stožiar",
                8: "Poškodený/otvorený rozvádzač"
            }
        };
    },
    mounted() {
        api.get(`/reportdefect/${this.city}/${this.point}`)
            .then(response => {
                this.result = response.data;
            })
            .catch(error => {
                alert(error);
            });
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();

            api.post(`/reportdefect`, {
                note: this.defect.note,
                city: this.city,
                point: this.point,
                defects: this.defect.defects,
                name: this.defect.name,
                phone: this.defect.phone,
                email: this.defect.email,
                agree: this.defect.agree
            })
                .then(response => {
                    this.showResult = true;
                    this.resultIcon = response.data.icon;
                    this.resultMessage = response.data.message;
                    // this.$bvToast.toast(" ", {
                    //     title: response.data.message,
                    //     variant: response.data.variant,
                    //     toaster: "b-toaster-top-right",
                    //     solid: true,
                    //     appendToast: true
                    // });
                    this.defect.note = "";
                    this.defect.defects = [];
                })
                .catch(({response}) => {
                    this.$bvToast.toast(" ", {
                        title: response.data,
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        solid: true,
                        appendToast: true
                    });
                });
        }
    },
    computed: {
        validateDefects() {
            return (
                this.defect.defects != undefined &&
                this.defect.defects.length > 0
            );
        }
    }
};
</script>

<style scoped></style>
